import "styles/landing-pages/weHelped.less";

import { Col, Row } from "antd";
import wtImage from "assets/images/home/uk-wt-image.png";
import wtVideo from "assets/videos/freelancing-captions.mp4";

const WeHelped = () => {
    return (
        <div className={"we-helped"}>
            <div className={"section-title"}>
            Real stories from happy customers.
            </div>

            <div className={"mt20 we-helped__subtitle"}>
                We have already collected over £15 million for our customers!
            </div>

            <div className="we-helped__section">
                <Row gutter={[24, 24]} align="middle">
                    <Col sm={24} md={24} lg={7} xl={7}>
                        <div className="we-helped__video-wrapper">
                            <video
                                controls
                                autoPlay
                                muted
                                loop
                                playsInline
                                className="we-helped__video"
                            >
                                <source src={wtVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                            </video>
                        </div>
                    </Col>
                    <Col sm={24} md={24} lg={17} xl={17}>
                        <div className="we-helped__image-wrapper">
                            <img
                                src={wtImage}
                                alt="wt"
                                className="we-helped__image"
                            />
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    );
};

export default WeHelped;
